import { Button } from "@freightsimple/ui-core/Controls/Button";
import { useNavigate } from "react-router-dom";
import ShipmentNotFound from "@/Shared/Shipment/CustomComponents/ShipmentNotFound";

interface LoadingShipmentErrorProps {
  /** Any other failure is a failed load: render LoadFailed instead. */
  code: 401 | 404;
}

export function ShipmentLoadingError(props: LoadingShipmentErrorProps) {
  const navigate = useNavigate();

  if (props.code === 404) {
    return <ShipmentNotFound />;
  }

  return (
    <div className="flex min-h-[60vh] animate-rise-in flex-col items-center justify-center px-6 py-12">
      <div className="mb-12 w-full max-w-[380px] animate-rise-in">
        <img
          className="block h-auto w-full"
          src="/images/unauthorized.svg"
          alt="Unauthorized access"
          role="img"
        />
      </div>

      <h1 className="mb-4 animate-rise-in text-center text-[42px] font-semibold tracking-[-0.5px] text-foreground [animation-delay:0.1s]">
        Confidential
      </h1>

      <p className="mb-8 max-w-[520px] animate-rise-in text-center text-[18px] leading-[1.6] text-content-secondary [animation-delay:0.2s]">
        Please sign in to your profile to view your quotes
      </p>

      <Button primary onClick={() => navigate("/sign-in")}>
        Sign in
      </Button>
      <div className="h-4" />

      <Button size="link" href="/book/details">
        No profile? Get started here
      </Button>
    </div>
  );
}
